import React from 'react';
import {
  Button,
  Icon,
  IconButton,
  Link,
  LoadingIndicator,
  Pressable,
  ScreenContainer,
  SimpleStyleScrollView,
  TextInput,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { ActivityIndicator, Image, Modal, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as AuthenticationApi from '../apis/AuthenticationApi.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import SideMenuBlock from '../components/SideMenuBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import resetGlobals from '../global-functions/resetGlobals';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import openImagePickerUtil from '../utils/openImagePicker';
import showAlertUtil from '../utils/showAlert';
import useWindowDimensions from '../utils/useWindowDimensions';
import waitUtil from '../utils/wait';

const AccountScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [confirmNewPassword, setConfirmNewPassword] = React.useState('');
  const [email, setEmail] = React.useState(Constants['USER_DETAILS']?.email);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [firstName, setFirstName] = React.useState(
    Constants['USER_DETAILS']?._profile_of_user?.first_name
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [lastName, setLastName] = React.useState(
    Constants['USER_DETAILS']?._profile_of_user?.last_name
  );
  const [newPassword, setNewPassword] = React.useState('');
  const [oldPassword, setOldPassword] = React.useState('');
  const [password, setPassword] = React.useState('password');
  const [phone, setPhone] = React.useState(
    Constants['USER_DETAILS']?._profile_of_user?.phone
  );
  const [profilePicture, setProfilePicture] = React.useState('');
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [toggleChangePassword, setToggleChangePassword] = React.useState(false);
  const [textInputValue, setTextInputValue] = React.useState('');
  const invalidForm = () => {
    const passwordExpr = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;

    let foundError = false;

    if (oldPassword.length < 1) {
      setErrorMessage('Please enter current password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }
    if (newPassword.length < 1) {
      setErrorMessage('Please enter new password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!newPassword.match(passwordExpr)) {
      setErrorMessage('Password must be at least 8 characters');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmNewPassword.length < 1) {
      setErrorMessage('Please confirm new password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmNewPassword != newPassword) {
      setErrorMessage('Passwords do not match');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    return foundError;
  };

  const resetVariables = () => {
    setErrorMessage('');
    setOldPassword('');
    setNewPassword('');
    setConfirmNewPassword('');
    setToggleChangePassword(false);
  };
  const authenticationUpdateProfilePicturePOST =
    AuthenticationApi.useUpdateProfilePicturePOST();
  const authenticationChangePasswordPOST =
    AuthenticationApi.useChangePasswordPOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                flex: { minWidth: Breakpoints.Laptop, value: 1 },
                flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
                maxHeight: {
                  minWidth: Breakpoints.Laptop,
                  value: dimensions.height,
                },
              },
              dimensions.width
            )}
          >
            <SideMenuBlock screen={'account'} />
            <AuthenticationApi.FetchAuthMeGET
              handlers={{
                onData: fetchData => {
                  try {
                    setProfilePicture(
                      fetchData?._profile_of_user?.profile_picture?.url
                    );
                    setGlobalVariableValue({
                      key: 'USER_DETAILS',
                      value: fetchData,
                    });
                  } catch (err) {
                    console.error(err);
                  }
                },
              }}
            >
              {({ loading, error, data, refetchAuthMe }) => {
                const fetchData = data?.json;
                if (loading) {
                  return <ActivityIndicator />;
                }

                if (error || data?.status < 200 || data?.status >= 300) {
                  return <ActivityIndicator />;
                }

                return (
                  <>
                    <SimpleStyleScrollView
                      bounces={true}
                      horizontal={false}
                      keyboardShouldPersistTaps={'never'}
                      nestedScrollEnabled={false}
                      showsHorizontalScrollIndicator={true}
                      showsVerticalScrollIndicator={true}
                      style={StyleSheet.applyWidth(
                        {
                          alignItems: {
                            minWidth: Breakpoints.Laptop,
                            value: 'center',
                          },
                          flex: { minWidth: Breakpoints.Laptop, value: 1 },
                          justifyContent: {
                            minWidth: Breakpoints.Laptop,
                            value: 'center',
                          },
                          paddingBottom: {
                            minWidth: Breakpoints.Laptop,
                            value: 30,
                          },
                          paddingTop: {
                            minWidth: Breakpoints.Laptop,
                            value: 30,
                          },
                        },
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            position: {
                              minWidth: Breakpoints.Laptop,
                              value: 'absolute',
                            },
                            right: { minWidth: Breakpoints.Laptop, value: 50 },
                            top: { minWidth: Breakpoints.Laptop, value: 50 },
                          },
                          dimensions.width
                        )}
                      >
                        <IconButton
                          onPress={() => {
                            try {
                              setGlobalVariableValue({
                                key: 'AUTH_TOKEN',
                                value: '',
                              });
                              resetGlobals(Variables, setGlobalVariableValue);
                              navigation.navigate('LoginScreen');
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          size={32}
                          color={StyleSheet.getWidthValue(
                            [
                              {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.Brand['App Red'],
                              },
                            ],
                            dimensions.width
                          )}
                          icon={'MaterialIcons/logout'}
                        />
                        <Text
                          accessible={true}
                          selectable={false}
                          {...GlobalStyles.TextStyles(theme)['Text'].props}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              {
                                color: {
                                  minWidth: Breakpoints.Laptop,
                                  value: palettes.Brand['App Red'],
                                },
                                fontFamily: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'OpenSans_400Regular',
                                },
                              }
                            ),
                            dimensions.width
                          )}
                        >
                          {'Logout'}
                        </Text>
                      </View>
                      {/* Account Screen */}
                      <View>
                        {/* Header */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                              flexDirection: {
                                minWidth: Breakpoints.Laptop,
                                value: 'row',
                              },
                              gap: { minWidth: Breakpoints.Laptop, value: 40 },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['Header'].props}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.TextStyles(theme)['Header'].style,
                                {
                                  fontSize: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 32,
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            {'Profile'}
                          </Text>

                          <View
                            style={StyleSheet.applyWidth(
                              {
                                borderColor: {
                                  minWidth: Breakpoints.Laptop,
                                  value: palettes.Brand.White,
                                },
                                borderRadius: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 6,
                                },
                                borderWidth: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 4,
                                },
                                padding: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 4,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            <Icon
                              color={palettes.Brand.White}
                              name={'AntDesign/caretdown'}
                              size={25}
                            />
                          </View>
                        </View>
                        {/* Account View */}
                        <View>
                          {/* Profile Picture */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                alignItems: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'center',
                                },
                                flexDirection: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'row',
                                },
                                marginBottom: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 24,
                                },
                                marginTop: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 24,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            <Pressable
                              onPress={() => {
                                const handler = async () => {
                                  try {
                                    const selectedImage =
                                      await openImagePickerUtil({
                                        mediaTypes: 'Images',
                                        allowsEditing: false,
                                        quality: 0.2,
                                        allowsMultipleSelection: false,
                                        outputBase64: true,
                                      });

                                    setIsLoading(true);
                                    const res = (
                                      await authenticationUpdateProfilePicturePOST.mutateAsync(
                                        { profile_picture: selectedImage }
                                      )
                                    )?.json;
                                    setIsLoading(false);
                                    if (res?.status) {
                                      setProfilePicture(selectedImage);
                                      setShowSuccess(true);
                                      await waitUtil({ milliseconds: 5000 });
                                      setShowSuccess(false);
                                    } else {
                                      setProfilePicture('');
                                    }
                                  } catch (err) {
                                    console.error(err);
                                  }
                                };
                                handler();
                              }}
                            >
                              {/* Border */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.White,
                                    },
                                    borderRadius: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 8,
                                    },
                                    borderWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 2,
                                    },
                                    height: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 100,
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    width: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 100,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <>
                                  {!(profilePicture && !isLoading) ? null : (
                                    <Image
                                      resizeMode={'cover'}
                                      {...GlobalStyles.ImageStyles(theme)[
                                        'Image'
                                      ].props}
                                      source={imageSource(`${profilePicture}`)}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.ImageStyles(theme)[
                                            'Image'
                                          ].style,
                                          {
                                            borderRadius: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 8,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    />
                                  )}
                                </>
                                {/* View 2 */}
                                <>
                                  {!isLoading ? null : (
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          alignItems: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'center',
                                          },
                                          height: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 100,
                                          },
                                          justifyContent: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'center',
                                          },
                                          width: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 100,
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      <>
                                        {!isLoading ? null : (
                                          <LoadingIndicator
                                            color={
                                              theme.colors.branding.primary
                                            }
                                            size={30}
                                            type={'circleFade'}
                                            color={StyleSheet.getWidthValue(
                                              [
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value:
                                                    palettes.App[
                                                      'Custom White'
                                                    ],
                                                },
                                              ],
                                              dimensions.width
                                            )}
                                          />
                                        )}
                                      </>
                                    </View>
                                  )}
                                </>
                                <>
                                  {!showSuccess ? null : (
                                    <Icon
                                      size={24}
                                      color={StyleSheet.getWidthValue(
                                        [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.Brand['App Green'],
                                          },
                                        ],
                                        dimensions.width
                                      )}
                                      name={'AntDesign/checkcircle'}
                                      style={StyleSheet.applyWidth(
                                        {
                                          bottom: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 6,
                                          },
                                          position: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'absolute',
                                          },
                                          right: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 6,
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    />
                                  )}
                                </>
                              </View>
                            </Pressable>

                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)['Text'].style,
                                  {
                                    color: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.White,
                                    },
                                    flex: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    fontFamily: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'Inter_400Regular',
                                    },
                                    fontSize: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 24,
                                    },
                                    textAlign: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {'Picture'}
                            </Text>
                          </View>
                          {/* Inputs */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                gap: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 24,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* First Name */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* First Name Input */}
                              <TextInput
                                autoCapitalize={'none'}
                                autoCorrect={true}
                                changeTextDelay={500}
                                onChangeText={newFirstNameInputValue => {
                                  const textInputValue = newFirstNameInputValue;
                                  try {
                                    setFirstName(newFirstNameInputValue);
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                                webShowOutline={true}
                                {...GlobalStyles.TextInputStyles(theme)[
                                  'Text Input'
                                ].props}
                                editable={false}
                                placeholder={''}
                                placeholderTextColor={palettes.Brand.Black}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextInputStyles(theme)[
                                      'Text Input'
                                    ].style,
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['App Blue Light'],
                                      },
                                      borderBottomWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderLeftWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderRightWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderTopWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                                value={firstName}
                              />
                              {/* First Name Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'First Name'}
                              </Text>
                            </View>
                            {/* Last Name */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Last Name Input */}
                              <TextInput
                                autoCapitalize={'none'}
                                autoCorrect={true}
                                changeTextDelay={500}
                                onChangeText={newLastNameInputValue => {
                                  try {
                                    setLastName(newLastNameInputValue);
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                                webShowOutline={true}
                                {...GlobalStyles.TextInputStyles(theme)[
                                  'Text Input'
                                ].props}
                                editable={false}
                                placeholder={''}
                                placeholderTextColor={palettes.Brand.Black}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextInputStyles(theme)[
                                      'Text Input'
                                    ].style,
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['App Blue Light'],
                                      },
                                      borderBottomWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderLeftWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderRightWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderTopWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                                value={lastName}
                              />
                              {/* Last Name Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Last Name'}
                              </Text>
                            </View>
                            {/* Phone */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Phone Input */}
                              <TextInput
                                autoCapitalize={'none'}
                                autoCorrect={true}
                                changeTextDelay={500}
                                onChangeText={newPhoneInputValue => {
                                  try {
                                    setPhone(newPhoneInputValue);
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                                webShowOutline={true}
                                {...GlobalStyles.TextInputStyles(theme)[
                                  'Text Input'
                                ].props}
                                editable={false}
                                placeholder={''}
                                placeholderTextColor={palettes.Brand.Black}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextInputStyles(theme)[
                                      'Text Input'
                                    ].style,
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['App Blue Light'],
                                      },
                                      borderBottomWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderLeftWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderRightWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderTopWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                                value={phone}
                              />
                              {/* Phone Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Phone'}
                              </Text>
                            </View>
                            {/* Email */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Email Input */}
                              <TextInput
                                autoCapitalize={'none'}
                                autoCorrect={true}
                                changeTextDelay={500}
                                onChangeText={newEmailInputValue => {
                                  try {
                                    setEmail(newEmailInputValue);
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                                webShowOutline={true}
                                {...GlobalStyles.TextInputStyles(theme)[
                                  'Text Input'
                                ].props}
                                disabled={true}
                                placeholder={''}
                                placeholderTextColor={palettes.Brand.Black}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextInputStyles(theme)[
                                      'Text Input'
                                    ].style,
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['App Blue Light'],
                                      },
                                      borderBottomWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderLeftWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderRightWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderTopWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                                value={email}
                              />
                              {/* Email Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Email Address'}
                              </Text>
                            </View>
                            {/* Password */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <Pressable
                                onPress={() => {
                                  try {
                                    setToggleChangePassword(
                                      !toggleChangePassword
                                    );
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                              >
                                {/* Password Input */}
                                <TextInput
                                  autoCapitalize={'none'}
                                  autoCorrect={true}
                                  changeTextDelay={500}
                                  onChangeText={newPasswordInputValue => {
                                    try {
                                      setPassword(newPasswordInputValue);
                                    } catch (err) {
                                      console.error(err);
                                    }
                                  }}
                                  webShowOutline={true}
                                  {...GlobalStyles.TextInputStyles(theme)[
                                    'Text Input'
                                  ].props}
                                  editable={false}
                                  placeholder={''}
                                  placeholderTextColor={palettes.Brand.Black}
                                  secureTextEntry={true}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextInputStyles(theme)[
                                        'Text Input'
                                      ].style,
                                      {
                                        backgroundColor: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.App['App Blue Light'],
                                        },
                                        borderBottomWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 2,
                                        },
                                        borderColor: {
                                          minWidth: Breakpoints.Laptop,
                                          value:
                                            palettes.Brand['App Blue Dark'],
                                        },
                                        borderLeftWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 2,
                                        },
                                        borderRightWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 2,
                                        },
                                        borderTopWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 2,
                                        },
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.Black,
                                        },
                                        textAlign: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'center',
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                  value={password}
                                />
                              </Pressable>
                              {/* Password Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Password'}
                              </Text>
                            </View>
                          </View>
                        </View>
                        {/* Billing&Payment Info */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                              gap: { minWidth: Breakpoints.Laptop, value: 30 },
                              marginLeft: {
                                minWidth: Breakpoints.Laptop,
                                value: '-25%',
                              },
                              marginRight: {
                                minWidth: Breakpoints.Laptop,
                                value: '-25%',
                              },
                              paddingTop: {
                                minWidth: Breakpoints.Laptop,
                                value: 40,
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['Text'].props}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.TextStyles(theme)['Text'].style,
                                {
                                  color: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.App['App Blue Light'],
                                  },
                                  fontFamily: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'Inter_500Medium',
                                  },
                                  fontSize: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 22,
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            {'Billing & Payment Information'}
                          </Text>
                          <Button
                            accessible={true}
                            iconPosition={'left'}
                            onPress={() => {
                              try {
                                navigation.navigate(
                                  'PaymentPlanSelectionScreen',
                                  { screen_from: 'account' }
                                );
                              } catch (err) {
                                console.error(err);
                              }
                            }}
                            {...GlobalStyles.ButtonStyles(theme)['Button']
                              .props}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.ButtonStyles(theme)['Button']
                                  .style,
                                {
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Green'],
                                  },
                                  width: {
                                    minWidth: Breakpoints.Laptop,
                                    value: '50%',
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                            title={'See Subscription Plans'}
                          />
                        </View>
                      </View>

                      <Modal
                        animationType={'none'}
                        supportedOrientations={['portrait', 'landscape']}
                        transparent={true}
                        visible={toggleChangePassword}
                      >
                        {/* Change Password */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: {
                                minWidth: Breakpoints.Laptop,
                                value: 'stretch',
                              },
                              backgroundColor: {
                                minWidth: Breakpoints.Laptop,
                                value: theme.colors.background.brand,
                              },
                              flex: { minWidth: Breakpoints.Laptop, value: 1 },
                              gap: { minWidth: Breakpoints.Laptop, value: 24 },
                              justifyContent: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                              marginLeft: {
                                minWidth: Breakpoints.Laptop,
                                value: '20%',
                              },
                              paddingLeft: {
                                minWidth: Breakpoints.Laptop,
                                value: '20%',
                              },
                              paddingRight: {
                                minWidth: Breakpoints.Laptop,
                                value: '20%',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          {/* Old Password */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                gap: { minWidth: Breakpoints.Laptop, value: 6 },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Password Input */}
                            <TextInput
                              autoCapitalize={'none'}
                              autoCorrect={true}
                              changeTextDelay={500}
                              onChangeText={newPasswordInputValue => {
                                try {
                                  setOldPassword(newPasswordInputValue);
                                } catch (err) {
                                  console.error(err);
                                }
                              }}
                              webShowOutline={true}
                              {...GlobalStyles.TextInputStyles(theme)[
                                'Text Input'
                              ].props}
                              placeholder={'Enter current password'}
                              placeholderTextColor={palettes.Brand.Black}
                              secureTextEntry={true}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextInputStyles(theme)[
                                    'Text Input'
                                  ].style,
                                  {
                                    backgroundColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.App['App Blue Light'],
                                    },
                                    borderBottomWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 2,
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand['App Blue Dark'],
                                    },
                                    borderLeftWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 2,
                                    },
                                    borderRightWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 2,
                                    },
                                    borderTopWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 2,
                                    },
                                    color: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand.Black,
                                    },
                                    textAlign: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                              value={oldPassword}
                            />
                            {/* Password Text */}
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)[
                                'Chart Text White'
                              ].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)[
                                    'Chart Text White'
                                  ].style,
                                  {
                                    fontFamily: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'Inter_400Regular',
                                    },
                                    fontSize: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 14,
                                    },
                                    textAlign: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {'Current Password'}
                            </Text>
                          </View>
                          {/* New Password */}
                          <View>
                            {/* Password */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Password Input */}
                              <TextInput
                                autoCapitalize={'none'}
                                autoCorrect={true}
                                changeTextDelay={500}
                                onChangeText={newPasswordInputValue => {
                                  try {
                                    setNewPassword(newPasswordInputValue);
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                                webShowOutline={true}
                                {...GlobalStyles.TextInputStyles(theme)[
                                  'Text Input'
                                ].props}
                                placeholder={'Enter new password'}
                                placeholderTextColor={palettes.Brand.Black}
                                secureTextEntry={true}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextInputStyles(theme)[
                                      'Text Input'
                                    ].style,
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['App Blue Light'],
                                      },
                                      borderBottomWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderLeftWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderRightWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderTopWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                                value={newPassword}
                              />
                              {/* Password Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'New Password'}
                              </Text>
                            </View>
                          </View>
                          {/* Confirm Password */}
                          <View>
                            {/* Password */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Password Input */}
                              <TextInput
                                autoCapitalize={'none'}
                                autoCorrect={true}
                                changeTextDelay={500}
                                onChangeText={newPasswordInputValue => {
                                  try {
                                    setConfirmNewPassword(
                                      newPasswordInputValue
                                    );
                                  } catch (err) {
                                    console.error(err);
                                  }
                                }}
                                webShowOutline={true}
                                {...GlobalStyles.TextInputStyles(theme)[
                                  'Text Input'
                                ].props}
                                placeholder={'Confirm new password'}
                                placeholderTextColor={palettes.Brand.Black}
                                secureTextEntry={true}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextInputStyles(theme)[
                                      'Text Input'
                                    ].style,
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['App Blue Light'],
                                      },
                                      borderBottomWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderLeftWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderRightWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      borderTopWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 2,
                                      },
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Black,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                                value={confirmNewPassword}
                              />
                              {/* Password Text */}
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      fontFamily: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'Inter_400Regular',
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 14,
                                      },
                                      textAlign: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Confirm New Password'}
                              </Text>
                            </View>
                          </View>
                          {/* Button View */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                alignItems: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'center',
                                },
                                gap: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 30,
                                },
                                marginTop: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 40,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)['Text'].style,
                                  {
                                    color: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.Brand['App Red'],
                                    },
                                    fontFamily: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'Inter_500Medium',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {errorMessage}
                            </Text>
                            <Button
                              accessible={true}
                              iconPosition={'left'}
                              onPress={() => {
                                const handler = async () => {
                                  try {
                                    const foundError = invalidForm();
                                    if (foundError) {
                                      return;
                                    }
                                    setIsLoading(true);
                                    const result = (
                                      await authenticationChangePasswordPOST.mutateAsync(
                                        {
                                          new_password: confirmNewPassword,
                                          old_password: oldPassword,
                                        }
                                      )
                                    )?.json;
                                    if (result?.status === 'Success!') {
                                      showAlertUtil({
                                        title: undefined,
                                        message:
                                          'Your password has been updated.',
                                        buttonText: 'Done',
                                      });

                                      resetVariables();
                                    } else {
                                      setErrorMessage(result?.message);
                                    }

                                    setIsLoading(false);
                                  } catch (err) {
                                    console.error(err);
                                  }
                                };
                                handler();
                              }}
                              {...GlobalStyles.ButtonStyles(theme)[
                                'New Submit Button'
                              ].props}
                              loading={isLoading}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.ButtonStyles(theme)[
                                    'New Submit Button'
                                  ].style,
                                  {
                                    fontSize: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 16,
                                    },
                                    width: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '50%',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                              title={'Update Password'}
                            />
                            {/* Cancel Link */}
                            <Link
                              accessible={true}
                              onPress={() => {
                                try {
                                  resetVariables();
                                } catch (err) {
                                  console.error(err);
                                }
                              }}
                              selectable={false}
                              {...GlobalStyles.LinkStyles(theme)['Cancel Link']
                                .props}
                              style={StyleSheet.applyWidth(
                                GlobalStyles.LinkStyles(theme)['Cancel Link']
                                  .style,
                                dimensions.width
                              )}
                              title={'cancel'}
                            />
                          </View>
                        </View>
                      </Modal>
                    </SimpleStyleScrollView>
                  </>
                );
              }}
            </AuthenticationApi.FetchAuthMeGET>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(AccountScreen);
